/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { QUESTION } from './terminology';

export const UTR = {
  NOTE: 'Further explanation / notes',
  FILES: 'Supporting Files',
};

export const INVITATION = {
  content: 'Thank you for joining the G17Eco platform.',
};

export const TOOLTIP = {
  notReporting: `Mark metric as "Not reporting" when your organisation is choosing not to answer the ${QUESTION.SINGULAR}.`,
  notApplicable:
    `Mark metric as "Not applicable" when the ${QUESTION.SINGULAR} is not relevant or applicable to your organisation.`,
  shareData: {
    restriction: 'This may be because you were referred or your subscription is subsidised',
  },
  privacy: `Mark metric as ‘Private’ when you want the ${QUESTION.SINGULAR} to be hidden from external stakeholders.`,
  comment:
    'Comments are internal only and will not appear on your download reports. If you have an assurer, they will be able to see the comments and interact with you via the comments.',
};
